/* global gsap */
// Place any jQuery/helper plugins in here.

(function plugins($) {
    // Initiate a utilities object in the window object to use globally.
    const utilities = {
        /**
         * Globals object to store variables that can be used across the app.
         * Starts with some jQuery elements that are commonly used.
         */
        globals: {
            $body:     $(document.body),
            $window:   $(window),
            $document: $(document),
        },

        // Utilities for the window
        qsa: (selector, context = document) => [...context.querySelectorAll(selector)] || [],
        qs:  (selector, context = document) => context.querySelector(selector) || null,

        has(prop, object) {
            return prop !== null && Object.prototype.hasOwnProperty.call(object, prop);
        },

        waitForGlobal: (key, callback) => {
            if (window[key]) {
                callback();
            } else {
                setTimeout(() => {
                    utilities.waitForGlobal(key, callback);
                }, 100);
            }
        },

        /**
         * An iteration utility for arrays and objects.
         * @param {Array|Object} object The object to iterate over.
         * @param {Function} callback The function called per iteration.
         */
        // each(object, callback, end = null, i = 0) {
        //     let length = object ? object.length : 0;
        //     if (typeof length === 'number' && length > -1) {
        //         length = end || length;
        //         while (i < length) {
        //             object[i] ? callback(object[i], i, object) : callback(i);
        //             i += 1;
        //         }
        //     } else {
        //         for (const key in object) {
        //             if (this.has(key, object))
        //                 callback(object[key], key, object);
        //         }
        //     }
        // },

        /**
         * Find out if the device is a touch device.
         */
        isTouch() {
            return 'ontouchstart' in window;
        },

        /**
         * Get the computed style of an element.
         * @param {Element} el HTML element.
         * @param {String} styleProp Style property.
         * @returns String
         */
        getStyle(el, styleProp, pseudoElt = null) {
            el = el || document.documentElement;
            if (el.currentStyle)
                return el.currentStyle[styleProp];
            if (window.getComputedStyle)
                return document.defaultView.getComputedStyle(el, pseudoElt).getPropertyValue(styleProp);
            return null;
        },

        // getCssVar(name) {
        //     return this.getStyle(document.documentElement, name);
        // },

        /**
         * Check if an element is at the bottom of the viewport.
         * @param {*} el HTML element.
         * @param {number} [offset=0]
         * @returns {boolean} True if the element is at the bottom of the viewport.
         */
        isElementViewport(el, options) {
            const offset = +options?.offset || 0;
            const origin = options?.origin || 'top';
            const rect = el.getBoundingClientRect();
            const winHeight = window.innerHeight || document.documentElement.clientHeight;

            if (origin === 'top')
                return rect.top + offset >= offset;
            if (origin === 'bottom')
                return rect.bottom + offset <= winHeight;
            if (origin === 'center')
                return rect.top + rect.height / 2 + offset <= winHeight / 2;
            return false;
        },

        cssVarSupport() {
            return window.CSS && CSS.supports('color', 'var(--primary)');
        },

        getHash() {
            return window.location.hash.substring(1) || '';
        },

        // attr(el, attr, value = null) {
        //     if (typeof attr === 'string' && typeof value === 'string')
        //         return el.setAttribute(attr, value);

        //     if (typeof attr === 'object') {
        //         for (const key in attr) {
        //             if (this.has(key, attr))
        //                 el.setAttribute(key, attr[key]);
        //         }
        //         return el;
        //     }

        //     if (value)
        //         return el.getAttribute(attr);

        //     return el;
        // },

        attr(selector, attr) {
            return gsap.set(selector, { attr });
        },

        getOffset(el) {
            const rect = el.getBoundingClientRect();
            return {
                top:  rect.top + document.body.scrollTop,
                left: rect.left + document.body.scrollLeft,
            };
        },

        checkCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            return parts.length === 2 ? parts.pop().split(';').shift() : false;
        },

        createCookie(name, value, days) {
            let expires = '';
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = `; expires=${date.toGMTString()}`;
            }
            document.cookie = `${name}=${value}${expires}; path=/`;
        },

        readCookie(name) {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ')
                    c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0)
                    return c.substring(nameEQ.length, c.length);
            }
            return null;
        },

        deleteCookie(name) {
            this.createCookie(name, '', -1);
        },

        /**
         * Get the current breakpoint
         * @returns {String} Current breakpoint depending on the css body pseudo element. ['sm', 'md', 'lg', 'xl']
         */
        getBreakpoint(sizes = null) {
            const currentSize = this.cssVarSupport() ? gsap.getProperty(':root', '--breakpoint') : this.getStyle(document.body, 'content', ':before').replace(/["']/g, '');
            sizes = typeof sizes === 'string' ? sizes.split(' ') : null;
            if (!sizes)
                return currentSize;
            return sizes.indexOf(currentSize) !== -1;
        },

        isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },

        // clamp function
        clamp(num, min, max) {
            return Math.min(Math.max(num, min), max);
        },

        randomString(length = 10) {
            let text = '';
            const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            for (let i = 0; i < length; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            return text;
        },

        flipTable(table) {
            const tbody = table.querySelector('tbody');
            const thead = table.querySelector('thead');
            const rows = table.querySelectorAll('tr');
            const newRows = [];

            rows.forEach((row) => {
                row.querySelectorAll('th, td').forEach((td, i) => {
                    const html = td.innerHTML;
                    const classNames = td.className;
                    if (newRows[i] === undefined)
                        newRows[i] = document.createElement('tr');

                    td = i === 0 ? document.createElement('th') : document.createElement('td');
                    td.innerHTML = html;
                    td.className = classNames;
                    newRows[i].appendChild(td);
                });
            });
            rows.forEach(e => e.remove());
            newRows.forEach((row, i) => (i === 0 ? thead.appendChild(row) : tbody.appendChild(row)));
        },

        /**
        * Gets an iterable element for the passed elements
        */
        // getList(selector, context = document) {
        //     if (typeof selector === 'string')
        //         selector = context.querySelectorAll(selector);

        //     const objName = Object.prototype.toString.call(selector);
        //     if (objName === '[object HTMLCollection]' || objName === '[object NodeList]')
        //         return [].slice.call(selector);
        //     if (objName === '[object Array]')
        //         return selector;
        //     return [selector];
        // },


        /**
         * Toggle a bootstrap dropdown programmatically.
         * @param {String|HTML Collection|NodeList} els Elements to check.
         * @param {String} action Action to perform. [hide, show]
         * @returns
         */
        toggleDropdown(els, action = 'show') {
            if (!els)
                return;
            const show = action === 'show';
            // const els = typeof els === 'string' ?
            gsap.utils.toArray(els).forEach((el) => {
                const menu  = el.querySelector('.dropdown-menu');
                const isShowing = menu.classList.contains('show');
                // If its already showing or its already hidden exit.
                if ((show && isShowing) || (!show && !isShowing))
                    return;

                const toggle = el.querySelector('[data-toggle="dropdown"]');
                menu.classList.toggle('show', show);
                el.classList.toggle('show', show);
                el.classList.toggle('focus', show);
                if (toggle)
                    toggle.setAttribute('aria-expanded', show);
            });
        },

        lockBody() {
            document.body.style.overflow = 'hidden';
        },
        unlockBody() {
            document.body.style.overflow = '';
        },

        ready(callback) {
            if (document.readyState !== 'loading')
                callback();
            else
                document.addEventListener('DOMContentLoaded', callback);
        },

        // kebabCase(str) {
        //     return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        // },

        // easings.
        easeOutQuint:   t => 1 + (--t) * t * t * t * t,
        easeOutQuad:    t => t * (2 - t),
        easeOutCubic:   t => (--t) * t * t + 1,
        easeOutQuart:   t => 1 - (--t) * t * t * t,
        easeInOutCubic: t => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
        addComma:       num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    };

    window.utilities = utilities;

    /**
    * shorthand clean log to console
    * @param {string} strName
    * @param {object variant} objValue
    */
    window.log = function log(strName, object, type = 'log') {
        // eslint-disable-next-line no-console
        console[type](type === 'table' ? object : strName, type === 'table' ? [strName] : object || '');
    };

    /**
    * Simple JQuery plugin to check if an element exists
    */
    $.fn.exists = function exists() {
        return !!this[0];
    };

    /**
     * Simple scroll to with animation thats cross browser compatible.
     * @param {Object} options setting
     * @param {Function} callback Callback after animation
     * @author Waldir Bolanos
     * @returns jQuery Object
     */
    // $.fn.scrollTo = function scrollTo(options, callback = () => {}) {
    //     // If no target than there is nothing to do.
    //     if (this.length < 1)
    //         return this;

    //     // Cache the body element.
    //     $.fn.scrollTo.bodyElement = $.fn.scrollTo.bodyElement || $('html, body');

    //     // Combine the options with defaults.
    //     options = $.extend({
    //         duration: 500,
    //         offset:   0,
    //     }, options);

    //     // Scroll to the element.
    //     $.fn.scrollTo.bodyElement.animate({
    //         scrollTop: this.offset().top + options.offset,
    //     }, options.duration, callback);
    //     return this;
    // };

    // $.fn.countUp = function f(options) {
    //     const {
    //         duration = 2000,
    //         delay = 0,
    //         start = 0,
    //         end = 1000,
    //         addComma = false,
    //         prefix = '',
    //         suffix = '',
    //         decimalPlaces = 0,
    //     } = { ...options };
    //     const frameDuration = 1000 / 60;
    //     const totalFrames = Math.round(duration / frameDuration);
    //     // const easeOutQuad = t => t * (2 - t);
    //     // const easeOutCubic = t => (--t) * t * t + 1;
    //     const easeOutQuint = t => 1 + (--t) * t * t * t * t;
    //     const commaAdd = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    //     return this.each((i, el) => {
    //         let frame = start;
    //         el.innerHTML = prefix + frame + suffix;
    //         setTimeout(() => {
    //             const counter = setInterval(() => {
    //                 frame += 1;
    //                 const progress = easeOutQuint(frame / totalFrames);
    //                 let currentCount = end * progress;
    //                 currentCount = decimalPlaces > 0 ? currentCount.toFixed(decimalPlaces) : Math.round(currentCount);
    //                 currentCount = addComma ? commaAdd(currentCount) : currentCount;
    //                 currentCount = prefix + currentCount + suffix;
    //                 el.innerHTML = currentCount;
    //                 if (frame === totalFrames)
    //                     clearInterval(counter);
    //             }, frameDuration);
    //         }, delay);
    //     });
    // };

    $.fn.createSVGCircle = function f(options) {
        options = $.extend({
            start:         0,
            end:           100,
            strokeColor:   'red',
            strokeWidth:   10,
            strokeBgColor: false,
            circleBgColor: false,
            circleRadius:  110,
            title:         '',
        }, options);

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');

        // Title
        if (options.title) {
            const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
            title.textContent = options.title;
            svg.appendChild(title);
        }

        options.normalizedRadius = options.circleRadius - options.strokeWidth / 2;
        options.circumference = options.normalizedRadius * 2 * Math.PI;
        options.boxSize = options.circleRadius * 2;
        options.offset = options.circumference - (options.end / 100 * options.circumference);

        // SVG attributes.
        utilities.attr(svg, {
            width:   options.boxSize,
            height:  options.boxSize,
            viewBox: `0 0 ${options.boxSize} ${options.boxSize}`,
            class:   'progress-ring__svg',
        });

        // Circle attributes.
        utilities.attr(circle, {
            stroke:              options.strokeColor,
            'stroke-dasharray':  `${options.circumference} ${options.circumference}`,
            'stroke-width':      options.strokeWidth,
            'stroke-dashoffset': options.circumference,
            fill:                'transparent',
            r:                   options.normalizedRadius,
            cx:                  options.circleRadius,
            cy:                  options.circleRadius,
        });

        // if background create a circle for background
        if (options.circleBgColor) {
            const bgCircle =  document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            utilities.attr(bgCircle, {
                fill: options.circleBgColor,
                r:    options.boxSize / 2,
                cx:   '50%',
                cy:   '50%',
            });
            svg.appendChild(bgCircle);
        }

        // if inner fill create a circle for inner fill
        if (options.strokeBgColor) {
            const innerCircle = circle.cloneNode();
            utilities.attr(innerCircle, {
                stroke: options.strokeBgColor,
                style:  'stroke-dashoffset: 0',
            });
            svg.appendChild(innerCircle);
        }

        circle.classList.add('progress-ring__circle');
        circle.setAttribute('data-progress-ring', '');
        circle.setAttribute('data-offset', options.offset);
        circle.setAttribute('data-start', options.start);
        circle.setAttribute('data-end', options.end);
        this.css({
            maxWidth:  options.boxSize,
            maxHeight: options.boxSize,
            position:  'relative',
        });

        svg.appendChild(circle);
        this.prepend(svg);

        return this;
    };

    gsap.registerEffect({
        name:           'counter',
        extendTimeline: true,
        defaults:       {
            end:        0,
            start:      0,
            ease:       'power4',
            increment:  1,
            digits:     2,
            prefix:     '',
            suffix:     '',
            wrapSuffix: true,
            wrapPrefix: true,
            addComma:   true,
            attr:       false,
        },
        effect: (targets, config) => {
            const duration = config.duration || gsap.defaults().duration || 0.5;
            const snap = gsap.utils.snap(config.increment);
            const settings = {
                ease: gsap.defaults().ease || config.ease,
            };
            config.prefix = config.prefix && config.wrapPrefix ? `<span class="prefix">${config.prefix}</span>` : config.prefix;
            config.suffix = config.suffix && config.wrapSuffix ? `<span class="suffix">${config.suffix}</span>` : config.suffix;

            // set the original textContent on the target'
            targets.forEach((el) => { el.dataset.originalText = el.textContent.trim(); });
            if (config.attr) {
                gsap.set(targets, { attr: { [config.attr]: config.start } });
                settings.attr = { [config.attr]: config.end };
                settings.modifiers = {
                    [config.attr](value) {
                        return snap(value);
                    },
                };
            } else {
                targets.forEach((el) => { el.textContent = config.start; });
                settings.innerHTML = config.end;
                settings.modifiers = {
                    innerHTML(value) {
                        value = Number(value);
                        const num = snap(value).toLocaleString('en-US', {
                            minimumIntegerDigits: config.digits,
                            useGrouping:          config.addComma,
                        });
                        return config.prefix + num + config.suffix;
                    },
                };
            }
            return gsap.timeline().to(targets, duration, settings, 0);
        },
    });
}(jQuery));
